<template>
	<div class="grid gap-4">
		<FormKit type="text" name="bussinessName" label="Naam van onderneming" />
		<FormKit
			type="loanlinkDate"
			name="startDate"
			label="Startdatum onderneming"
		/>
		<FormKit
			type="select"
			placeholder="Kies..."
			name="legalStructure"
			label="Rechtsvorm onderneming"
			select-icon="down"
			:options="legalStructureOptions"
		/>
		<FormKit type="text" name="kvkNumber" label="KvK-nummer" />
		<FormKit type="text" name="rsin" label="RSIN" />
		<FormKit type="text" name="sbi" label="SBI-code" />
		<div class="grid gap-4 lg:grid-cols-3">
			<FormKit
				type="loanlinkCurrency"
				name="resultYearOne"
				:label="`Resultaat ${currentYear}`"
			/>
			<FormKit
				type="loanlinkCurrency"
				name="resultYearTwo"
				:label="`Resultaat ${currentYear - 1}`"
			/>
			<FormKit
				type="loanlinkCurrency"
				name="resultYearThree"
				:label="`Resultaat ${currentYear - 2}`"
			/>
		</div>
		<FormKit
			type="loanlinkCurrency"
			name="averageResult"
			label="Gemiddeld resultaat"
		/>
		<FormKit
			type="loanlinkCurrency"
			name="assessedIncome"
			label="Toetsinkomen"
		/>
		<FormKit
			type="loanlinkPercentage"
			name="percentageCounted"
			label="Percentage meetellen voor toetsinkomen"
		/>
	</div>
</template>

<script lang="ts" setup>
import type { OndernemingLegalStructureType } from "@loanlink-nl/model-app";
import type { InventarisationSelectOption } from "@/models/inventarisation/InventarisationSelectOption";

const currentYear = new Date().getFullYear() - 1;

const legalStructureOptions: InventarisationSelectOption<OndernemingLegalStructureType>[] =
	[
		{ label: "BV", value: "BV Besloten vennootschap" },
		{
			label: "CV",
			value: "CV Commanditaire vennootschap",
		},
		{ label: "Eenmanszaak", value: "EMZ Eenmanszaak" },
		{ label: "Maatschap", value: "MA Maatschap" },
		{ label: "NV", value: "NV Naamloze vennootschap" },
		{ label: "Stichting", value: "ST Stichting" },
		{
			label: "VOF",
			value: "VOF Vennootschap onder firma",
		},
	];
</script>
